export const userRegisterLangSorter = (lang: string): "en-US" | "de-DE" => {
    return lang == 'De_ch' ? 'de-DE' : 'en-US';
}